import createAPI from '../../../utils/api/api.js'

const api = createAPI()

const listsElements = [
  {
    name: 'sports',
    apiPath: 'getSports'
  },
  {
    name: 'ages',
    apiPath: 'getAges'
  },
  {
    name: 'partners',
    apiPath: 'getPartners'
  },
  {
    name: 'roles',
    apiPath: 'getRoles'
  },
  {
    name: 'genders',
    apiPath: 'getGenders'
  },
  {
    name: 'countries',
    apiPath: 'getCountries'
  },
  {
    name: 'tournaments',
    apiPath: 'getTournaments'
  },
  {
    name: 'teams',
    apiPath: 'getTeams'
  },
  {
    name: 'matches',
    apiPath: 'getTranslations'
  },
  {
    name: 'events',
    apiPath: 'getEventTypes'
  }
]

const currentApiPath = listName => {
  const { apiPath } = listsElements.find(el => el.name === listName)

  return apiPath
}

const gettingList = async (state, dispatch) => {
  if (!state.data.length) {
    await dispatch('fetch')
  }

  return state.data
}

const fetchList = async (name, commit) => {
  let apiPromise

  if (apiPromise) {
    return apiPromise
  }

  const getServerRequestPromise = async () => {
    const params = name === 'events' ? { filter: { scope: 'adv' } } : {}
    const { data, recordsTotal, recordsFiltered } = await api[currentApiPath(name)](params)

    commit('SET_LIST', { data, recordsTotal: recordsFiltered || recordsTotal })
    commit('SET_LOADING', false)
  }

  apiPromise = getServerRequestPromise()

  return apiPromise
}

const resetList = async commit => {
  commit('RESET_LIST')
}

const updateList = async (commit, state, value, name) => {
  const mutationName = `UPDATE_LIST`

  const {
    data: { length },
    count,
    isLoading
  } = state

  if (length === count || isLoading) return

  commit('LIST_UPDATE_STATUS', { name, value: true })

  try {
    if (name === 'tournaments') {
      const { sportId } = state

      const { data } = await api[currentApiPath(name)]({
        start: length,
        length: 100,
        'filter[sport_id]': sportId,
        'with_attributes[0]': 'ctitles',
        'with_attributes[1]': 'rights'
      })

      commit(mutationName, data)
    } else {
      const { data } = await api[currentApiPath(name)]({
        start: length,
        length: 100
      })

      commit(mutationName, data)
    }

    commit('LIST_UPDATE_STATUS', { value: false })
  } catch (e) {
    commit('LIST_UPDATE_STATUS', { value: false })

    throw e
  }
}

const searchList = async (commit, state, value, name) => {
  const { search, self_id, sportId } = value
  const { sportId: stateSportId } = state

  const mutationName = `SET_LIST`

  if (search || self_id) {
    try {
      const payload = self_id
        ? {
          filter: {
            self_id
          }
        }
        : {
          search: {
            value: search
          },
          filter: {
            sport_id: sportId || stateSportId
          }
        }
      if (sportId || stateSportId) {
        payload.sport_id = sportId || stateSportId
      }

      const { data, recordsTotal } = await api[currentApiPath(name)](payload)

      return { data, recordsTotal }
    } catch (e) {
      throw e
    }
  }

  const {
    data: { length }
  } = state

  if (length) return

  try {
    const { data, recordsTotal } = await api[currentApiPath(name)]

    commit(mutationName, { data, recordsTotal })

    return { data, recordsTotal }
  } catch (e) {
    throw e
  }
}

export { gettingList, fetchList, resetList, updateList, searchList }
